<!-- Loading Indicator -->
<div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="height: 50vh;">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div *ngIf="!isLoading && noDataAvailable" class="no-data-container text-center p-20">
  <app-empty-state>
  </app-empty-state>
</div>

<div *ngIf="!isLoading && !noDataAvailable">
  <mat-dialog-actions *ngIf="!hideActionButtons"
    class="report-actions d-flex justify-content-end align-items-center flex-wrap">
    <mat-checkbox color="primary" [(ngModel)]="showCategory">Category & SubCategory</mat-checkbox>
    <div>
      <a mat-icon-button *ngIf="Prescriptions.length === 0" (click)="printReportDirect()">
        <i-tabler name="printer" class="text-primary icon-30 d-flex"></i-tabler>
      </a>

      <a mat-icon-button *ngIf="Prescriptions.length > 0" [matMenuTriggerFor]="menu" class="d-flex align-items-center">
        <i-tabler name="printer" class="text-primary icon-30 d-flex"></i-tabler>
      </a>

      <mat-menu #menu="matMenu">
        <a mat-menu-item (click)="printReportDirect()">All</a>
        <a mat-menu-item (click)="printReportOnly()">Report Only</a>
        <a mat-menu-item (click)="printPrescriptionOnly()">Prescription</a>
      </mat-menu>
    </div>
  </mat-dialog-actions>


  <div class="report-scroll-container" [class.report-scroll-container-disabled]="!useInternalScroll">
    <mat-card class="report-card">
      <!-- Dynamic Report Section -->
      <div #printbody>
        <div class="dynamic-section">
          <!-- Loop through all report categories first -->
          <div #reportSection>
            <div class="report-section" *ngFor="let group of groupedReports; let sectionIndex = index">
              <div class="report-section-header d-flex justify-content-between align-items-center gap-8">
                <div class="d-flex align-items-center gap-8">
                  <h4 class="category-type f-s-16 f-w-600 m-0">{{ group.categoryType }}</h4>
                </div>
              </div>

              <ng-container *ngIf="!isDiagnosisGroup(group.categoryType); else diagnosisSection">
                <div class="report-grid m-b-16">
                  <div *ngFor="let cat of group.categories" class="report-category"
                    [class.report-category-no-category]="!showCategory">
                    <div class="left-col category-col f-w-600" *ngIf="showCategory">
                      {{ cat.category }}
                    </div>

                    <div class="subcategory-list">
                      <div *ngFor="let sub of cat.subCategories" class="report-sub-row"
                        [class.report-sub-row-no-category]="!showCategory">
                        <div class="middle-col f-w-600" *ngIf="showCategory">
                          {{ sub.subCategory }}
                        </div>

                        <div class="right-col">
                          <ul class="finding-list m-0">
                            <li *ngFor="let item of sub.items">
                              <span>{{ item.clinicalItemName }}</span>
                              <span *ngIf="item.duration"> ({{ item.duration }})</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-template #diagnosisSection>
                <div class="report-grid diagnosis-grid m-b-16">
                  <div *ngFor="let cat of group.categories" class="report-category"
                    [class.report-category-no-category]="!showCategory">
                    <div class="left-col category-col f-w-600" *ngIf="showCategory">
                      {{ cat.category }}
                    </div>

                    <div class="subcategory-list">
                      <div *ngFor="let sub of cat.subCategories" class="report-sub-row"
                        [class.report-sub-row-no-category]="!showCategory">
                        <div class="middle-col f-w-600" *ngIf="showCategory">
                          {{ sub.subCategory }}
                        </div>

                        <div class="right-col">
                          <ul class="finding-list m-0">
                            <li *ngFor="let item of sub.items">
                              <span>{{ item.clinicalItemName }}</span>
                              <span *ngIf="item.duration"> ({{ item.duration }})</span>
                              <span *ngIf="item.note"> - {{ item.note }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="treatment-advice-section m-b-16" *ngIf="treatmentAdvice">
              <h4 class="category-type f-s-16 f-w-600 m-0">{{ 'LABEL.TREATMENT_ADVICE' | translate }}</h4>
              <div class="treatment-advice-content">
                {{ treatmentAdvice }}
              </div>
            </div>
          </div>

          <!-- Show all prescriptions at the end -->
          <div #prescriptionSection>
            <div *ngIf="Prescriptions.length > 0" class="prescription-print-section">

              <img src="/assets/images/svgs/icon-rx.svg" class="logo-rx" />
              <div class="diagnosis-section" *ngIf="isPrescriptionPrint">{{ 'LABEL.DIAGNOSIS' | translate }} : {{
                diagnosisList }}</div>

              <div class="prescription">
                <div class="prescription-header">
                  <div class="cell-prescription drug-col">{{ 'LABEL.DRUG_NAME' | translate }}</div>
                  <div class="cell-prescription pattern-col">{{ 'LABEL.DRUG_PATTERN' | translate }}</div>
                  <div class="cell-prescription duration-col">{{ 'LABEL.DURATION' | translate }}</div>
                  <div class="cell-prescription meal-col">{{ 'LABEL.MEAL_RELATION' | translate }}</div>
                  <div class="cell-prescription instruction-col">{{ 'LABEL.INSTRUCTION' | translate }}</div>
                </div>

                <ng-container *ngFor="let prescription of Prescriptions">
                  <ng-container *ngFor="let item of prescription.prescriptionItems">
                    <div class="prescription-row">
                      <div class="cell-prescription drug-col">{{ getDrugName(item.drugId) }}</div>
                      <div class="cell-prescription pattern-col">{{ item.dosePattern }}</div>
                      <div class="cell-prescription duration-col">{{ item.duration }}</div>
                      <div class="cell-prescription meal-col">{{ item.mealRelation }}</div>
                      <div class="cell-prescription instruction-col">{{ item.instruction }}</div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>

        </div>
      </div>
    </mat-card>
  </div>
</div>
